<script>
import { onMount } from 'svelte';
import ContentOldVersion from './partials/ContentOldVersion.svelte';
import { PlansStore } from './Plans.store.js';
import { UpdateSubscriptions } from './SubscriptionsStore';
import Subscriptions from './Subscriptions.svelte';
import { sortItems } from 'tripod-styles/src/libraries/sortItems';
import { turpial } from '../libraries/turpial.js';
import { Connect3Pod } from '../libraries/Connect3Pod.js';
import HeadersTabs from 'tripod-styles/src/components/Others/HeaderTabs/HeadersTabs.svelte'
import {HeaderTabController} from 'tripod-styles/src/components/Others/HeaderTabs/HeaderTabController'
import StaticLink from 'tripod-styles/src/components/Buttons/StaticLink.svelte'
import ContentNewVersion from './partials/ContentNewVersion.svelte';
import RestartableController from 'tripod-styles/src/components/Elements/RestartableController.svelte';
import restart_component from 'tripod-styles/src/components/Elements/restart_component';
import {Contents} from 'tripod-styles/src/components/ContentsPlatform.store'
import "./core-plans.scss"
import { PlanInterface } from "tripod-styles/src/models/PlansInterface.js";
import { calculateRegionalPrice } from 'tripod-styles/src/libraries/regional_prices_calculator';
import { loadCurrencyRates, CurrenciesManagerStore } from 'tripod-styles/src/libraries/CurrenciesManagerStore';
import { StoreCart } from '../register/steps/StoreCart';






export let user = {};
export let affiliate = {};
export let Data = {};
export let onSelectPlan = function(){}; // for internal modules


// to set only certain plans and show it publicly, including private ones.
tripod_plans.available_plans = tripod_plans?.available_plans ?? [];

let lang = tripod_plans.lang ?? {};

let userFromCampaign = Data.userFromCampaign ?? null;
if(typeof user.userFromCampaign !== "undefined" || userFromCampaign === null){
    userFromCampaign = user?.userFromCampaign ?? user?.user_from_campaign ?? null;
}
// code country for regional prices: CO, MX, BR, CL, PE
let code_country = user?.code_country ?? "CO";
let tags = user?.more_tags ?? user?.more_tags ?? [];
if(typeof tags === "string" && tags !== ""){
    try {
        tags = tags.split(",");
        tags = tags.filter((tag)=> tag !== "");
    } catch (error) {
        console.log(error);
    }
}
if(userFromCampaign !== "" && typeof userFromCampaign === "string"){
    tags.push(userFromCampaign);
}

let section_restart = [{}]
let currencies_conversion = [];

let loaded_language = false;
window.lang_selected = lang.lang_selected ?? "es";
let lang_selected = window.lang_selected;
if((window?.ContentsAll ?? null) !== null){
    loaded_language = true;
}
if(!loaded_language){
    Contents.load_both(lang_selected, ()=>{
        window.ContentsAll = $Contents;
        loaded_language = true;
    });
}


/**
 * Clases for main conainer of core-plans. 
 * This will not work on Register.js 
 * unless you pass tripod_plans.main_class (css classes)
 * @type {String}
 */
let custom_classes = tripod_plans.custom_classes ?? "";

let plans_rows; // restartable component
let plans_module_version = window.plans_module_version ?? "new";
let memberships = [];
let membership_names = [];
let membership_types = [];
let membership_selected = tripod_plans.selected ?? "designs";
let showOnly = tripod_plans.showOnly ?? false;

let customCardPlan = tripod_plans.customCardPlan ?? "minimal";
let title = tripod_plans.title ?? false;
let go_back = tripod_plans.go_back ?? false;
/**
 * plan selected in a external enviroment
 * will not work in internal enviroment.
 */
let plan_id_selected = tripod_plans.plan_id_selected ?? null;
let on_go_back = tripod_plans.on_go_back ?? function(){};
let subtitle = tripod_plans.subtitle ?? false;
let button_header = tripod_plans.button_header ?? false;
let button_header_on_click = tripod_plans.button_header_on_click ?? false;
let custom_title = tripod_plans.custom_title ?? false;
let subscriptions = tripod_plans.subscriptions ?? [];


let plans = tripod_plans.plans ?? false;
let all_plans = false;
let all_addons = false;
let stripe_subs = tripod_plans.stripe_subs ?? false;
let showPlans = tripod_plans.showPlans ?? true;
let showProducts = tripod_plans.showProducts ?? true;
let links = tripod_plans.links ?? true;
let plansSelector = tripod_plans?.links?.plansSelector ?? false;
let host = tripod_plans.host;
let section = null;
let fetched = false;
let is_fetching = false;
let interval = "month";
let has_chooser_plan_module = false;
if(typeof tripod_register !== "undefined"){
    has_chooser_plan_module = tripod_register?.has_chooser_plan_module ?? false;
}


// restore cart to avoid multi selection on go back.
StoreCart.restore();

console.log(membership_selected)
// set membership_selected in plans store.
PlansStore.update("membership_selected", membership_selected);

if(custom_title === false){
    title = window.get_contents_all("ctn_PVsSRO") ?? "Membresías";
    subtitle = window.get_contents_all("ctn_8XG-IW") ?? "Tenemos la membresía justo a la medida de tu negocio";
}

// updater plans for external enviroment
window.tripod_plans.update_plans_state = ()=>{
    PlansStore.reset();
};


$: {
    if(section !== null){
        turpial.linkCSS({
            target: section,
            url: [
                "https://cdn.jsdelivr.net/gh/Yerikmiller/3pod-us.github.io@latest/icons/platform/tripod-pack/tripod-pack.css",
                "https://cdn.jsdelivr.net/gh/Yerikmiller/3pod-us.github.io@latest/icons/iconsax/vuesax-outline/IconFont.css",
                "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
            ], ready: ()=>{}
        })
    }
}


window.tripod_plans.lang.on_plan_type = window.tripod_plans.lang?.on_plan_type ?? {
    PLAN: "Membresía",
    PRODUCT: "Pago Único",
}

let available_custom_cards = [
    "minimal",
    "default"
];

let find_custom_card = available_custom_cards.find( (r)=>  r === customCardPlan);
if(typeof find_custom_card === "undefined" || typeof customCardPlan !== "string"){
    customCardPlan = "minimal"
}


tripod_plans.updateSubscriptions = (r)=> UpdateSubscriptions(r);

UpdateSubscriptions();

if(plansSelector !== false){

    if(typeof plansSelector !== "object"){
        plansSelector = false;
    }
}
let membership_icons_fetched = {
    funnels: "icon-tripod-video-tick",
    suite_website: "icon-tripod-T-world",
    campaigns: "icon-tripod-speaker",
    video_hosting: "icon-tripod-folder-video",
    ia_content: "icon-tripod-v-magicpen",
    suite: "icon-tripod-video-tick",
    designs: "icon-tripod-design-tools",
};


let showCurrentMemberships = tripod_plans.showCurrentMemberships ?? false;

if(showOnly !== false){
    tripod_plans.selected = membership_selected = showOnly;
}

let referralsDiscounts = [];
let ordered_memberships = [];
function getReferredBy(public_key)
{
    public_key = user?.public_key ?? "";
    let referred_by = user?.referred_by ?? user?.referrer_id ?? "";
    Connect3Pod(`${host}public/api/v1/affiliates/referredByData`, {
        data: {
            public_key_user: public_key.split("").reverse().join(""),
            public_key_affiliate: referred_by.split("").reverse().join(""),
        },
        ready: (data)=>{
            try {
                data = JSON.parse(data);
                referralsDiscounts = data.referralsDiscounts;
            } catch (error) {
                referralsDiscounts = {};
            }
        }
    })
}



function onReadygetPlans(data, addons){
    /**
     * Si quieres cambiar el orden de los botones y sus títulos
     * debes cambiar el orden de $memberships, $membership_names & $membership_types
    */

    // getReferredBy(user.referred_by); // REMOVED redundant and problematic fetch
    
    let showOnly = tripod_plans.showOnly ?? false;
    let order = tripod_plans.order ?? false;
    let fields = tripod_plans.lang.fields ?? false;
    if(order === false){
        console.error("You need to supply a order field. ex: [...memberships]")
        return;
    }
    
    if(showOnly !== false){
        data = {
            [showOnly]: data[showOnly],
        }
        
    }

    // parse memberships and create a visual membership for websites
    //data = {...create_websites_suite(data)};

    

    

    memberships = data;
    tripod_plans.plans = memberships;
    all_addons = addons;
    tripod_plans.addons = addons;

    if(tags.length > 0){
        if(tags.includes("Proveedores3Pod")){
            const membs = {};
            for (const membership_type in memberships) {
                let plans = memberships[membership_type];
                plans = plans.filter(function(plan){
                    if(membership_type !== "suite"){
                        return true;
                    }
                    if(plan.tag !== null){
                        if(plan.tag === "Proveedores3Pod"){
                            plan.is_available = "public";
                            return true;
                        }
                    }
                    return false;
                })
                membs[membership_type] = plans;
            }
            memberships = membs;
        }
        console.log(memberships)
    }
    
    
    if(Array.isArray(tripod_plans.available_plans)){
        if(tripod_plans.available_plans.length > 0){
            const available_plans = tripod_plans.available_plans;
            const membs = {};
            for (const membership_type in memberships) {
                let plans = memberships[membership_type];

                // INCLUDE ALL PLANS FOR A SPECIFIC MEMBERSHIP
                if(available_plans.includes(membership_type)){
                    membs[membership_type] = plans;
                    continue;
                }

                plans = plans.filter(function(plan){
                    if(available_plans.includes(plan.__id__)){
                        plan.is_available = "public";
                        return true;
                    }

                    return false;
                })

                if(plans.length === 0){
                    continue;
                }

                if(typeof membs[membership_type] === "undefined"){
                    membs[membership_type] = [];
                }

                membs[membership_type] = plans;
            }
            memberships = membs;
        }
    }

    
    
    Object.values(memberships).map(( /** @type {Array<PlanInterface>} */ plans, key )=>{
        let name = Object.keys(memberships)[key];
        
        plans.map(( /** @type {PlanInterface} */ plan, position )=>{
            if((plan.discountsPlan ?? null) !== null){
                plan.discountPercent = plan.discountsPlan.discountPercent ?? null;
                if(plan.discountPercent !== null){
                    plan.discountPercent = +(plan.discountPercent)
                }
            }
            

            memberships[name][position].price_plan = +(plan.price_plan);
            memberships[name][position].position_plan = +(plan.position_plan);
            memberships[name][position].price_on_year_monthly = +(plan.price_plan)*12;

            // Regional Pricing Overrides & Fallback Calculation
            const regionalPriceData = calculateRegionalPrice(plan, code_country, currencies_conversion);
            if (regionalPriceData) {
                console.log(`Applying regional pricing for ${plan.name_plan}:`, regionalPriceData);
                memberships[name][position].price_plan = regionalPriceData.price_plan;
                memberships[name][position].price_on_year_monthly = regionalPriceData.price_on_year_monthly;
                memberships[name][position].currency = regionalPriceData.currency;
                memberships[name][position].unit_coin = regionalPriceData.unit_coin;

                if (regionalPriceData.interval_year_price !== null) {
                    memberships[name][position].interval_year_price = regionalPriceData.interval_year_price;
                    memberships[name][position].price_on_year_yearly = regionalPriceData.price_on_year_yearly;
                }
            }

            if(plan.interval_year_price ?? "" !== ""){
                memberships[name][position].price_on_year_yearly = memberships[name][position].price_on_year_yearly ?? (+(plan.interval_year_price)*12);
            }
            
            if(plan.type === "PRODUCT"){
                memberships[name][position].price_on_year_monthly = +(plan.price_plan);
                memberships[name][position].price_on_year_yearly = +(plan.price_plan);
            }

            memberships[name][position].is_recommended = memberships[name][position]?.is_recommended ?? "Default";
            
            memberships[name] = sortItems(memberships[name], "price_on_year_monthly", "asc");
        })
    })
    
    let membershipsOrdered = {};
    
    /**
     * Para ordenar los datos con el campo order.
     * para mostrar solo uno de los elementos
    */
    
    

    order.map(( item )=>{
        if(typeof memberships[item] === "undefined"){return}
        const plans = memberships[item];
        let has_available = false;
        for (const index in plans) {
            const plan = plans[index];
            if(plan.is_available === "public"){
                has_available = true;
            }
            if(tags.length > 0){
                if(tags.includes(plan.tag ?? "")){
                    has_available = true;
                }
            }
        }

        

        

        if(!has_available){return}

        if(showOnly !== false){
            if(item === showOnly){
                membershipsOrdered[item] = memberships[item]
                return;
            }
        }else{
            membershipsOrdered[item] = memberships[item]
        }
    })    
    memberships = membershipsOrdered;
    /**
     * ordered by importance
    */
    membership_names = fields;
    /**
     * ordered by importance
    */
    membership_types = order;
    
    plans = tripod_plans.plans;
    all_plans = Object.values(plans).filter(( subs )=>{
        let get = [];
        subs.map((plan)=>{
            get.push(plan)
        })
        return get;
    }).flat();
    PlansStore.update("plans_views", memberships[membership_selected]);
    return plans;
}


// parse memberships and create a visual membership for website
function create_websites_suite(memberships){
    let plans_websites = [];
    let memberships_parsed = {};
    for (const index in memberships) {
        const membership_name = index;
        /**
         * @type {Array}
         */
        let plans = memberships[index];
        
        if(membership_name === "suite"){
            // create another membership_type (only for frontend to visually separate suite types)
            // when suite has 0 in benefits.embudos create another membership_type
            const suite_website_name = membership_name+"_only_websites";
            const plans_available = [];
            for (const index in plans) {
                const plan = plans[index];
                let embudos = plan?.benefits?.embudos?.value ?? false;
                if(embudos === 0 && plan.type === "PLAN" && plan.is_available === "public"){
                    if(typeof memberships_parsed[suite_website_name] === "undefined"){
                        memberships_parsed[suite_website_name] = [];
                    }
                    plan.membership_type = suite_website_name;
                    memberships_parsed[suite_website_name].push(plan);
                    
                    plans_websites.push(plan);
                    //membership_types.push(membership_name+"_only_websites");
                }else{
                    plans_available.push(plan);
                }
            }
            memberships_parsed[membership_name] = plans_available;
            continue;
        }

        memberships_parsed[membership_name] = plans;
    }
    return memberships_parsed;
}

function changeInterval(interval_checked){
    interval = interval_checked;
}

async function initLoadData() {
    if (fetched || is_fetching) return;
    is_fetching = true;
    console.log("CorePlans: Starting initLoadData");
    
    let urlGetPlans = host + "api/getPlans";
    let urlGetAddons = host + "api/getAddons";
    let urlGetCurrencyConversion = host + "api/getCurrencies";

    if (userFromCampaign !== "" && userFromCampaign !== null) {
        urlGetPlans = host + "api/getPlans?tag=" + btoa(userFromCampaign);
    }

    const fetchJSON = async (url) => {
        try {
            const response = await fetch(url, { method: 'POST' });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return await response.json();
        } catch (e) {
            console.error(`Fetch error for ${url}:`, e);
            throw e;
        }
    };

    try {
        // Load currency rates using the shared library/store
        await loadCurrencyRates(host);
        
        const [plans, addons] = await Promise.all([
            fetchJSON(urlGetPlans),
            fetchJSON(urlGetAddons),
        ]);

        // Get currency data from the shared Store
        currencies_conversion = $CurrenciesManagerStore.currencies_conversion;
        
        console.log("CorePlans: Data fetched successfully", { plansStatus: plans.status, currencies: currencies_conversion.length });

        window.getPlans3Pod = () => plans?.response || [];
        window.getAddons3Pod = () => addons?.response || [];
        window.getCurrenciesConversion3Pod = () => currencies_conversion;

        if (plans.status === "error") {
            console.error("An error occurred loading API getPlans from 3pod.");
        } else if (plans.status === "success") {
            setTimeout(function(){
                onReadygetPlans(plans.response, (addons?.response || {}));
                fetched = true;
                section_restart = [{}];
            }, 1000)
        }
    } catch (error) {
        console.warn("CorePlans: loadData failure", error);
        memberships = [];
    } finally {
        is_fetching = false;
    }
}

onMount(() => {
    console.count("CorePlans Mounted");
    initLoadData();
});


let boxes_container;
function changeMembership(membership_selected){

    try {
        tripod_plans.onChangeMembership(memberships[membership_selected])
    } catch (error) {
        
    }

    PlansStore.update("plans_views", memberships[membership_selected]);
    PlansStore.update("membership_selected", membership_selected);
    membership_selected = membership_selected;
} 


let header_tabs = new HeaderTabController();
header_tabs.on_change = (item)=>{
    item = item ?? null;
    PlansStore.update("current_item_tab", item);
    plans_rows = restart_component();
}

$:console.log(`Membresía: ${membership_selected}`)

$: {
    if(membership_types.length > 0){
        let items = Object.values(memberships);
        let selected_items = [];
        items.map((plans)=>{
            let membership_type = plans[0].membership_type;

            selected_items.push({
                icon: membership_icons_fetched[membership_type],
                title: membership_names[membership_type],
                current: membership_type === membership_selected,
                membership: membership_type,
                on_click: ()=>{
                    if(plansSelector === false){
                        changeMembership(membership_type);
                    }else{
                        window.location.href = plansSelector[plans[0].membership_type];
                        return 'preventDefault'
                    }
                }
            })
        });

        header_tabs.set_items(selected_items);
    }
}

/*
[
    {
        icon: "";
        title: "";
        current: false;
        on_click: ()=>{};
    }
]
*/



</script>
{#if loaded_language}
    <RestartableController bind:data={section_restart}>
        <section bind:this={section} class="main-section-plans {custom_classes}">
            {#if section !== null}
            <header>
                {#if go_back}
                    <StaticLink on:click={on_go_back}>
                        <span class="has-text-primary button-go-back">
                            {go_back}
                        </span>
                    </StaticLink>
                {/if}
                {#if title !== false}
                    <div class="is-flex is-justify-content-space-between is-relative">
                        <header-titles class="is-block">
                            {#if has_chooser_plan_module}
                                <figure>
                                    <img width="70px" src="https://main-bucket.3pod.io/Logo3Pod.svg" alt="Logo de 3Pod">
                                </figure>
                            {/if}
                            {#if title !== false}
                                <h2 class="has-text-black font-size-24 font-restricted-size-20-touch fw700 has-text-left">
                                    {title}
                                </h2>
                            {/if}
                            {#if !has_chooser_plan_module}
                                <p class="has-text-black has-text-left" style="line-height: 20px;">
                                    {subtitle}
                                </p>
                            {/if}
                        </header-titles>
                        {#if button_header}
                            <button class="button is-primary" on:click={button_header_on_click}>
                                {button_header}
                            </button>
                        {/if}
                    </div>
                {/if}
                {#if has_chooser_plan_module}
                    <h2 class="has-text-black font-size-20 fw700 has-text-left">
                        {Contents.set_content(window.get_contents_all("ctn_11Tj") ?? "Paso {{ stetp }} de {{ current }}", {
                            stetp: "2",
                            current: "3"
                        })}
                    </h2>
                {/if}    
            </header>
            <main class="main-container">
                {#if showCurrentMemberships === true}
                    <Subscriptions subscriptions={subscriptions} tripod_plans={window.tripod_plans} lang={lang} all_addons={all_addons} all_plans={all_plans} stripe_subs={stripe_subs} />
                {/if}
                {#if showPlans}
                    {#if showOnly === false}
                        {#if header_tabs.items.length > 1}
                        
                            <!-- buttons navigation between memberships -->
                            <HeadersTabs controller={header_tabs} icon_classes="font-size-24 font-size-14-touch" tabs_classes={'fit-content-width'} />
                        {/if}
                        
                    {/if}
                    <RestartableController bind:data={plans_rows}>
                        {#if plans_module_version !== "new"}
                            <ContentOldVersion
                                changeInterval={changeInterval}
                                lang={lang}
                                membership_selected={membership_selected}
                                onSelectPlan={onSelectPlan}
                                affiliate={affiliate}
                                user={user}
                                interval={interval}
                                customCardPlan={customCardPlan}
                                tripod_plans={window.tripod_plans}
                            />
                        {/if}
                        {#if plans_module_version === "new"}
                            <ContentNewVersion
                                changeInterval={changeInterval}
                                lang={lang}
                                membership_selected={membership_selected}
                                onSelectPlan={onSelectPlan}
                                affiliate={affiliate}
                                user={user}
                                interval={interval}
                                customCardPlan={customCardPlan}
                                tripod_plans={window.tripod_plans}
                            />
                        {/if}
                    </RestartableController>
                {/if}
            </main>
            {/if}
        </section>
    </RestartableController>
{/if}
<style>
.main-section-plans{
    background-color: #fff;
    border-radius: 20px;
}
.main-section-plans{
    padding: 2.75rem;
}
section{
    padding-bottom: 2rem;
}
.main-container{
    margin-top: 1rem;
}
@media only screen and (max-width:900px){
    header {
        padding: 0 1.25rem;
    }
    .main-container{
        margin-top: 0rem;
    }
    .main-section-plans{
        background-color: transparent;
        padding: 1.25rem;
    }
}
/*
section :global(button[data-membership-type='suite'][data-plan-id='pl_LdtycZ']),
section :global(button[data-membership-type='suite'][data-plan-id='pl_Te8nj-']){
    pointer-events: none;
    opacity: 0.5;
}*/

section :global(button[data-membership-type='suite'][data-plan-id='pl_-He4DX']),
section :global(button[data-membership-type='suite'][data-offer-type='essential-or-low']){
    pointer-events: all;
    opacity: 1;
}
</style>